import { render, staticRenderFns } from "./Dialog.vue?vue&type=template&id=833c4b2e&scoped=true&"
import script from "./Dialog.vue?vue&type=script&setup=true&lang=js&"
export * from "./Dialog.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./Dialog.vue?vue&type=style&index=0&id=833c4b2e&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "833c4b2e",
  null
  
)

export default component.exports